import React from "react";
import _ from "lodash";
import { useQuery } from "@apollo/client";

import AppBar from "@material-ui/core/AppBar";

import CloseIcon from "@material-ui/icons/Close";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";

import { makeStyles, useTheme } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
// import Link from "@material-ui/core/Link";
import Card from "@material-ui/core/Card";

import { formatPhoneNumber } from "~/shared/utils/sharedUtils";
import {
  setProperVisitCookiesForRefills,
  setCookiesAndRedirectToPerformanceFollowUpVisit,
  setCookiesAndRedirectToInsomniaFollowUpVisit,
  setProperVisitCookies,
} from "~/visits/utils/visitUtils";

import {
  usePortalStyles,
  kickNavy,
  kickRed,
  kickLightBlue,
} from "../styles/portalStyles";

import { addDays, isPast } from "date-fns";

import pluralize from "pluralize";

import {
  CONSULTATION_TYPE_ABBREVIATION_INSOMNIA_FOLLOW_UP,
  CONSULTATION_TYPE_ABBREVIATION_INSOMNIA,
  CONSULTATION_TYPE_ABBREVIATION_PERFORMANCE_ANXIETY_FOLLOW_UP,
  CONSULTATION_TYPE_ABBREVIATION_PERFORMANCE_ANXIETY,
  DOCTOR_VISIT_STATUS_PENDING_VERIFICATION,
  DOCTOR_VISIT_STATUS_READY,
  DOCTOR_VISIT_STATUS_PENDING,
  FILL_PHARMACY_ID_TRUEPILL,
  VISIT_TYPE_INSOMNIA_FOLLOW_UP,
  VISIT_TYPE_PERFORMANCE_ANXIETY_FOLLOW_UP,
} from "~/shared/sharedConstants";
import {
  isOriginalOrFollowUpVisit,
  isDoctorVisitComplete,
  isPharmacyPickupOrderType,
  hasRefillsAvailable,
  numRefillsRemaining,
  displayFriendlyPrescriptionExpirationLongDate,
  displayFriendlyShortenedOrderType,
  displayFriendlyLongDate,
  getOrderTypeImageSrc,
  getVisitTypeImageSrc,
  getConsultationNameFromVisitType,
  latestVisitCompletedAtOrVisitStartedAt,
  isVisitTypeInsomnia,
} from "~/shared/utils/sharedUtils";

import {
  DOCTOR_VISIT_STATUS_CLOSED_COMPLETE,
  DOCTOR_VISIT_STATUS_PENDING_PHOTOS,
  DOCTOR_VISIT_STATUS_PENDING_PAYMENT,
  VISIT_TYPE_INSOMNIA,
  VISIT_TYPE_PERFORMANCE_ANXIETY,
  COLOR_KICK_RED,
  COLOR_KICK_BLUE,
  COLOR_KICK_YELLOW,
} from "~/shared/sharedConstants";

import { GET_PATIENT_RECORD } from "./portalQueries";
import {
  setFollowUpVisitFlag,
  clearUserAlreadyExists,
} from "../../visits/utils/visitCookies";

import { isEmpty, findIndex } from "lodash";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  // menuButton: {
  //   marginRight: theme.spacing(2),
  //   [theme.breakpoints.up("sm")]: {
  //     display: "none",
  //   },
  // },
  // // necessary for content to be below app bar
  // toolbar: theme.mixins.toolbar,
  // drawerPaper: {
  //   width: drawerWidth,
  // },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
}));

function AffiliateLink({ setShowAffiliateLink }) {
  const { loading, error, data } = useQuery(GET_PATIENT_RECORD);
  if (data && data.patientRecord?.patient?.affiliateToken) {
    return (
      <AppBar
        style={{
          color: "white",
          textAlign: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: "1300",
          padding: "4px 0",
        }}
      >
        <div style={{ alignSelf: "center" }}>
          <div style={{ padding: "0 20px" }}>
            Share this link with your friends to give them a discount off their
            first visit!
          </div>
          <div>
            <a
              style={{ color: kickLightBlue, fontSize: "16px" }}
              target="_blank"
              href={`${window.location.origin}?via=${data.patientRecord.patient.affiliateToken}`}
            >
              gokick.com?via=
              {data.patientRecord.patient.affiliateToken}
            </a>
          </div>
        </div>
        <div
          style={{
            cursor: "pointer",
            position: "absolute",
            right: "20px",
          }}
        >
          <CloseIcon onClick={() => setShowAffiliateLink(false)} />
        </div>
      </AppBar>
    );
  }
  return null;
}

const orderItemsByID = {};

function GetPatientRecord(props) {
  const { classes } = props;
  const { loading, error, data } = useQuery(GET_PATIENT_RECORD);

  if (loading) return "Loading...";
  if (error) return `Error! ${error.message}`;

  // build orderItemsByID map
  data.patientRecord.visits.forEach(({ orderItems }) => {
    orderItems?.forEach((orderItem) => {
      orderItemsByID[orderItem.id] = orderItem;
    });
  });

  return <ShowVisits patientRecord={data.patientRecord} classes={classes} />;
}

function PendingVisitCard({ visit }) {
  return (
    <DrawVisitCard
      visit={visit}
      medicationOrVisitName={getConsultationNameFromVisitType(visit.visitType)}
      expiresAtText={displayFriendlyLongDate(
        latestVisitCompletedAtOrVisitStartedAt(
          visit.visitDate,
          visit.patientCompletedAt
        )
      )}
      refillsRemainingTest={""}
      imageSrc={getVisitTypeImageSrc(visit.visitType)}
      cardText={
        <>
          <div>
            Thanks for completing your visit.
            <br />
            We'll send an email as soon as it's reviewed.
          </div>
        </>
      }
    ></DrawVisitCard>
  );
}

function DrawIncompleteVisitCard(visit, patient) {
  // return if not pending payment or pending photos
  if (
    visit.status != DOCTOR_VISIT_STATUS_PENDING_PAYMENT &&
    visit.status != DOCTOR_VISIT_STATUS_PENDING_PHOTOS &&
    visit.status != DOCTOR_VISIT_STATUS_PENDING_VERIFICATION
  ) {
    return null;
  }

  return (
    <DrawVisitCard
      visit={visit}
      medicationOrVisitName={getConsultationNameFromVisitType(visit.visitType)}
      expiresAtText={displayFriendlyLongDate(
        latestVisitCompletedAtOrVisitStartedAt(
          visit.visitDate,
          visit.patientCompletedAt
        )
      )}
      refillsRemainingTest={""}
      imageSrc={getVisitTypeImageSrc(visit.visitType)}
      buttonText={"Finish Incomplete Visit  >"}
      buttonOnClick={() => {
        switch (visit.status) {
          case DOCTOR_VISIT_STATUS_PENDING_PHOTOS:
            setCookiesAndRedirectToSelectPharmacy(
              patient.id,
              patient.email,
              patient.phone,
              visit
            );
            break;
          case DOCTOR_VISIT_STATUS_PENDING_PAYMENT:
            setCookiesAndRedirectToSelectPharmacy(
              patient.id,
              patient.email,
              patient.phone,
              visit
            );
            break;
        }
      }}
    ></DrawVisitCard>
  );
}

function ShowVisits(props) {
  const { patientRecord } = props;
  if (patientRecord == null) return;

  let hasNoPerformanceAnxietyVisitsToShow =
    findIndex(patientRecord.visits, {
      visitType: VISIT_TYPE_PERFORMANCE_ANXIETY,
    }) == -1;

  let hasNoInsomniaTreatmentsToShow =
    findIndex(patientRecord.visits, {
      visitType: VISIT_TYPE_INSOMNIA,
    }) == -1;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <h3 style={{ textAlign: "center", marginBottom: "20px" }}>
        Your Treatments and Prescriptions
      </h3>

      {patientRecord.visits
        .filter((v) =>
          [DOCTOR_VISIT_STATUS_PENDING, DOCTOR_VISIT_STATUS_READY].includes(
            v.status
          )
        )
        .map((visit) => {
          return (
            <React.Fragment key={visit.id}>
              <PendingVisitCard visit={visit} patient={patientRecord.patient} />
            </React.Fragment>
          );
        })}

      {/* show insomnia promo if there are visits, but no insomnia visits */}
      {hasNoInsomniaTreatmentsToShow &&
        !hasNoPerformanceAnxietyVisitsToShow && (
          <Card
            style={{
              border: "1px solid gray",
              borderRadius: "6px",
              marginBottom: "20px",
              paddingBottom: "20px",
              width: "350px",
              display: "flex",
              alignItems: "center",
              textAlign: "center",
              flexDirection: "column",
              backgroundColor: COLOR_KICK_BLUE,
            }}
          >
            <p
              style={{
                fontSize: "20px",
                fontFamily: "BasisGrotesquePro-Bold",
                color: "white",
                marginTop: "20px",
                marginBottom: "16px",
              }}
            >
              — Now Available —
            </p>
            <p
              style={{
                fontSize: "16px",
                fontFamily: "BasisGrotesquePro-Bold",
                color: "white",
                marginBottom: "16px",
                textAlign: "center",
              }}
            >
              Trusted Performance Sleep Treatments from
              <br /> an Expert Stanford Sleep Doctor
            </p>
            <p
              style={{
                fontSize: "16px",
                fontFamily: "BasisGrotesquePro-Regular",
                color: COLOR_KICK_YELLOW,
                marginBottom: "16px",
                textAlign: "center",
              }}
            >
              Go from 'Sleep-Deprived' to 'Feeling Alive' without Bedtime
              Procrastination
            </p>
            <div
              style={{
                width: "88%",
                borderRadius: "2px",
                padding: "12px 10px 6px 10px",
                marginBottom: "24px",
                backgroundColor: "white",
                fontFamily: "BasisGrotesquePro-Regular",
              }}
            >
              <p style={{ fontFamily: "BasisGrotesquePro-Regular" }}>
                <span
                  style={{
                    fontSize: "16px",
                    fontFamily: "BasisGrotesquePro-Bold",
                  }}
                >
                  Sleep medications include:
                </span>
                <br /> Hydroxyzine, Trazodone, Ramelteon, <br />
                Quetiapine, Cyclobenzaprine, Guanfacine & more
              </p>
              <p style={{ fontFamily: "BasisGrotesquePro-Regular" }}>
                <span
                  style={{
                    fontSize: "16px",
                    fontFamily: "BasisGrotesquePro-Bold",
                  }}
                >
                  Unlock up to 37% savings on:
                </span>
                <br />
                Fitness Memberships, Yoga Classes, Sleep Equipment & more with
                your HSA or FSA
              </p>
              <p style={{ fontFamily: "BasisGrotesquePro-Bold" }}>
                Starting at only $69
              </p>
            </div>
            <Button
              type="submit"
              onClick={async () => {
                window.location.href = `/visits/inc/1`;
              }}
              color="primary"
              size="large"
              style={{
                padding: "10px",
                backgroundColor: COLOR_KICK_RED,
                color: "white",
                width: "320px",
                marginBottom: "10px",
              }}
            >
              Start Insomnia Visit&nbsp;
              <NavigateNextIcon />
            </Button>
          </Card>
        )}

      {patientRecord.visits.map((visit) => {
        return (
          <React.Fragment key={visit.id}>
            {ShowVisitPrescriptionsForVisit(visit, patientRecord.patient)}
            {DrawIncompleteVisitCard(visit, patientRecord.patient)}
          </React.Fragment>
        );
      })}

      {hasNoPerformanceAnxietyVisitsToShow && hasNoInsomniaTreatmentsToShow && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <p style={{ fontSize: "20px", textAlign: "center" }}>
            Treatments and prescriptions will appear here after your first
            doctor visit is reviewed
          </p>

          <Button
            type="submit"
            onClick={async () => {
              window.location.href = `/visits/pac/1`;
            }}
            color="primary"
            size="large"
            style={{
              padding: "12px",
              backgroundColor: "#3f3f82",
              color: "white",
              marginTop: "10px",
              width: "320px",
            }}
          >
            Start Performance Anxiety Visit&nbsp;
            <NavigateNextIcon />
          </Button>

          {
            <Button
              type="submit"
              onClick={async () => {
                window.location.href = `/visits/inc/1`;
              }}
              color="primary"
              size="large"
              style={{
                padding: "10px",
                backgroundColor: "#3f3f82",
                color: "white",
                marginTop: "10px",
                width: "320px",
              }}
            >
              Start Insomnia Visit&nbsp;
              <NavigateNextIcon />
            </Button>
          }
        </div>
      )}
    </div>
  );
}
function DrawVisitCard(props) {
  const {
    visit,
    medicationOrVisitName,
    expiresAtText,
    refillsRemainingText,
    buttonText,
    imageSrc,
    buttonOnClick,
    cardText,
  } = props;

  let imgHeight = "100px";
  let imgWidth = "214px";
  let imgLeft = "16px";

  if (isVisitTypeInsomnia(visit.visitType)) {
    imgHeight = "190px";
    imgWidth = "160px";
    imgLeft = "0";
  }

  return (
    <Card
      key={visit.id}
      style={{
        border: "1px solid gray",
        borderRadius: "6px",
        marginBottom: "20px",
        paddingBottom: "20px",
        width: "350px",
        display: "flex",
        alignItems: "center",
        textAlign: "center",
        flexDirection: "column",
      }}
    >
      <h3>{medicationOrVisitName}</h3>
      <p>
        {expiresAtText}
        <br />
        {refillsRemainingText}
      </p>
      <img
        style={{
          height: imgHeight,
          width: imgWidth,
          position: "relative",
          left: imgLeft,
          marginTop: "10px",
        }}
        src={imageSrc}
      ></img>
      <br />
      {buttonText && (
        <Button
          type="submit"
          onClick={buttonOnClick}
          color="primary"
          size="large"
          style={{
            backgroundColor: "#3f3f82",
            color: "white",
            marginTop: "20px",
            width: "300px",
          }}
        >
          {buttonText}
        </Button>
      )}
      {cardText && (
        <>
          <div
            style={{
              marginTop: "20px",
              padding: "0 20px",
              color: kickNavy,
              fontSize: "16px",
            }}
          >
            {cardText}
          </div>
          {isPharmacyPickupOrderType(visit.orderType)
            ? showLocalPharmacy(visit.pharmacyInfo, true)
            : showShippingAddress(visit)}
        </>
      )}
    </Card>
  );
}
function ShowVisitPrescriptionsForVisit(visit, patient) {
  switch (visit.visitType) {
    case VISIT_TYPE_PERFORMANCE_ANXIETY:
    case VISIT_TYPE_PERFORMANCE_ANXIETY_FOLLOW_UP:
      return ShowPerformanceAnxietyPrescription(visit, patient);

    case VISIT_TYPE_INSOMNIA:
    case VISIT_TYPE_INSOMNIA_FOLLOW_UP:
      return ShowInsomniaTrialPrescriptions(visit, patient);
  }

  return ShowPerformanceAnxietyPrescription(visit, patient);
}

function showShippingAddress(visit) {
  return (
    <div
      style={{
        margin: "10px 0 20px",
        fontSize: "15px",
        backgroundColor: kickLightBlue,
        border: "1px solid #ddd",
        padding: "12px",
        borderRadius: "6px",
        width: "280px",
      }}
    >
      <div style={{ color: kickRed, margin: "0 0 6px" }}>
        Your meds will be shipped to:
      </div>
      <div>
        {visit.address1} {visit.address2}
      </div>
      <div>
        {visit.city}, {visit.usState} {visit.zip}
      </div>
    </div>
  );
}

function showLocalPharmacy(pharmacyInfo, pending = false) {
  if (!pharmacyInfo) return null;
  return (
    <div
      style={{
        margin: "10px 0 20px",
        fontSize: "15px",
        backgroundColor: kickLightBlue,
        border: "1px solid #ddd",
        padding: "12px",
        borderRadius: "6px",
        width: "280px",
      }}
    >
      <div style={{ color: kickRed, margin: "0 0 6px" }}>
        {pending
          ? "Your medication will be available at:"
          : "Pick up your medication at:"}
      </div>
      <div style={{ fontWeight: "bold", fontSize: "18px", margin: "0 0 6px" }}>
        {pharmacyInfo.pharmacyName}
      </div>
      <div>
        {pharmacyInfo.pharmacyAddress1} {pharmacyInfo.pharmacyAddress2}
      </div>
      <div>
        {pharmacyInfo.pharmacyCity}, {pharmacyInfo.pharmacyState}{" "}
        {pharmacyInfo.pharmacyZip}
      </div>
      <div style={{ marginTop: "4px" }}>
        <a
          href={`tel:${pharmacyInfo.pharmacyPhone}`}
          style={{ textDecoration: "none" }}
        >
          {formatPhoneNumber(pharmacyInfo.pharmacyPhone)}
        </a>
      </div>
    </div>
  );
}

function deDupedPrescriptions(visit) {
  let prescriptionsByMedName = {};
  const sortedRxs = _.sortBy(visit.visitPrescriptions, "createdAt").reverse();
  sortedRxs.forEach((rx) => {
    if (!prescriptionsByMedName[rx.medicationName]) {
      prescriptionsByMedName[rx.medicationName] = rx;
    }
  });

  return _.sortBy(Object.values(prescriptionsByMedName), "createdAt").reverse();
}

function ShowInsomniaTrialPrescriptions(visit, patient) {
  // const { patient, visit } = props;

  // only show completed visit prescriptions that have a doctorPrescription attached
  if (
    !isDoctorVisitComplete(visit.status) ||
    isEmpty(visit.visitPrescriptions)
  ) {
    return null;
  }

  return (
    <Card
      key={visit.id}
      style={{
        border: "1px solid gray",
        borderRadius: "6px",
        marginBottom: "20px",
        paddingBottom: "20px",
        width: "350px",
        display: "flex",
        alignItems: "center",
        textAlign: "center",
        flexDirection: "column",
      }}
    >
      <h3>{getConsultationNameFromVisitType(visit.visitType)}</h3>
      <h4>
        {visit.visitPrescriptions.map((p) => {
          return (
            <span key={`${visit.id}-${p.id}`}>
              {`${p.medicationName} ${p.medicationDosage}`}
              <br />
            </span>
          );
        })}
      </h4>
      <p>{displayFriendlyLongDate(visit.visitDate)}</p>

      {isPharmacyPickupOrderType(visit.orderType) &&
        showLocalPharmacy(visit.pharmacyInfo)}

      <img
        style={{
          width: "160px",
          height: "190px",
          position: "relative",
          marginTop: "10px",
        }}
        src={getVisitTypeImageSrc(visit.visitType)}
      ></img>
      <br />
      <p>
        Adjust Sleep Meds or Refill Anytime
        <br />
        Included With Membership at No Extra Cost
      </p>
      {/* Closed visits - show refill or follow up button */}
      {visit.status == DOCTOR_VISIT_STATUS_CLOSED_COMPLETE && (
        <Button
          type="submit"
          onClick={async () => {
            setCookiesAndRedirectToInsomniaFollowUpVisit(
              patient.id,
              patient.email,
              patient.phone,
              visit.address1,
              visit.address2,
              visit.city,
              visit.usState,
              visit.zip
            );
          }}
          color="primary"
          size="large"
          style={{
            backgroundColor: "#3f3f82",
            color: "white",
            width: "300px",
          }}
        >
          Start Follow-up Visit&nbsp;
          <NavigateNextIcon />
        </Button>
      )}
    </Card>
  );
}

function RenderVisitPrescription({ visit, prescription }) {
  let doRefill = false;
  let prescriptionExpired = false;
  let numRefills = numRefillsRemaining(
    prescription.refills,
    prescription.numRefillsFilled
  );

  const orderItem = orderItemsByID[prescription.orderItemID];

  if (!orderItem) return null;

  // only check if there are refills on non-pharmacy pickup (i.e. mail order) orders
  if (!isPharmacyPickupOrderType(orderItem.productSlug)) {
    doRefill = hasRefillsAvailable(
      prescription.refills,
      prescription.numRefillsFilled
    );

    // check if prescription has expired
    let prescriptionDate = new Date(prescription.createdAt);
    let prescriptionExpires = addDays(prescriptionDate, 362);

    if (isPast(prescriptionExpires)) {
      prescriptionExpired = true;
      doRefill = false;
    }

    // if fill pharmacy is Truepill - set to no refills so we require a follow up visit
    if (
      prescription.fillPharmacyID == FILL_PHARMACY_ID_TRUEPILL ||
      prescription.fillPharmacyID == ""
    ) {
      doRefill = false;
      numRefills = 0;
    }
  }

  return (
    <div
      style={{
        border: "1px solid #ddd",
        borderRadius: "4px",
        margin: "0 -5px 20px",
        padding: "10px",
      }}
    >
      <h4>
        {prescription.medicationName} {prescription.medicationDosage} - {"  "}
        {displayFriendlyShortenedOrderType(orderItem.productSlug)}
      </h4>
      <p>
        {prescriptionExpired ? "Expired " : "Expires "}
        {displayFriendlyPrescriptionExpirationLongDate(visit.visitDate)}
        <br />
        {/* don't show number of refills if pharmacy pickup or prescription has expired*/}
        {isPharmacyPickupOrderType(orderItem.productSlug) || prescriptionExpired
          ? ""
          : numRefills == 0
          ? "No refills remaining"
          : `${pluralize("refill", numRefills, true)} remaining`}
      </p>
      {isPharmacyPickupOrderType(orderItem.productSlug)
        ? showLocalPharmacy(visit.pharmacyInfo)
        : showShippingAddress(visit)}
      <img
        style={{
          height: "100px",
          width: "214px",
          position: "relative",
          left: "16px",
          marginTop: "10px",
        }}
        src={getOrderTypeImageSrc(orderItem.productSlug)}
      ></img>
    </div>
  );
}

function ShowPerformanceAnxietyPrescription(visit, patient) {
  // const { patient, visit } = props;

  // only show completed visit prescriptions that have a doctorPrescription attached
  if (
    !isDoctorVisitComplete(visit.status) ||
    !isOriginalOrFollowUpVisit(visit.orderType) ||
    isEmpty(visit.visitPrescriptions)
  ) {
    return null;
  }

  // get prescriptions unique by medication name

  // TODO: Fix this  - only showing first prescription
  // grab the first prescription for now
  var prescription = visit.visitPrescriptions[0];
  // console.log("prescription:", prescription);

  let doRefill = false;
  let prescriptionExpired = false;
  let numRefills = numRefillsRemaining(
    prescription.refills,
    prescription.numRefillsFilled
  );

  // only check if there are refills on non-pharmacy pickup (i.e. mail order) orders
  if (!isPharmacyPickupOrderType(visit.orderType)) {
    doRefill = hasRefillsAvailable(
      prescription.refills,
      prescription.numRefillsFilled
    );

    // check if prescription has expired
    let prescriptionDate = new Date(prescription.createdAt);
    let prescriptionExpires = addDays(prescriptionDate, 362);

    if (isPast(prescriptionExpires)) {
      prescriptionExpired = true;
      doRefill = false;
    }

    // if fill pharmacy is Truepill - set to no refills so we require a follow up visit
    if (
      prescription.fillPharmacyID == FILL_PHARMACY_ID_TRUEPILL ||
      prescription.fillPharmacyID == ""
    ) {
      doRefill = false;
      numRefills = 0;
    }
  }

  return (
    <Card
      key={visit.id}
      style={{
        border: "1px solid gray",
        borderRadius: "6px",
        marginBottom: "20px",
        paddingBottom: "20px",
        width: "350px",
        display: "flex",
        alignItems: "center",
        textAlign: "center",
        flexDirection: "column",
      }}
    >
      <h3>{getConsultationNameFromVisitType(visit.visitType)}</h3>
      {visit.orderItems?.length ? (
        deDupedPrescriptions(visit).map((prescription) => (
          <RenderVisitPrescription
            key={`visitPrescriptions-${prescription.id}`}
            visit={visit}
            prescription={prescription}
          />
        ))
      ) : (
        <>
          <h4>
            {prescription.medicationName} {prescription.medicationDosage} -{" "}
            {"  "}
            {displayFriendlyShortenedOrderType(visit.orderType)}
          </h4>
          <p>
            {prescriptionExpired ? "Expired " : "Expires "}
            {displayFriendlyPrescriptionExpirationLongDate(visit.visitDate)}
            <br />
            {/* don't show number of refills if pharmacy pickup or prescription has expired*/}
            {isPharmacyPickupOrderType(visit.orderType) || prescriptionExpired
              ? ""
              : numRefills == 0
              ? "No refills remaining"
              : `${pluralize("refill", numRefills, true)} remaining`}
          </p>
          {isPharmacyPickupOrderType(visit.orderType) &&
            showLocalPharmacy(visit.pharmacyInfo)}
          <img
            style={{
              height: "100px",
              width: "214px",
              position: "relative",
              left: "16px",
              marginTop: "10px",
            }}
            src={getOrderTypeImageSrc(visit.orderType)}
          ></img>
        </>
      )}
      <br />

      {/* Closed visits - show refill or follow up button */}
      {visit.status == DOCTOR_VISIT_STATUS_CLOSED_COMPLETE && (
        <Button
          type="submit"
          onClick={async () => {
            if (doRefill) {
              setCookiesAndRedirectToPerformanceVisitPaymentRefill(
                patient,
                visit,
                prescription
              );
            } else {
              setCookiesAndRedirectToPerformanceFollowUpVisit(
                patient,
                prescription
              );
            }
          }}
          color="primary"
          size="large"
          style={{
            backgroundColor: "#3f3f82",
            color: "white",
            marginTop: "20px",
            width: "300px",
          }}
        >
          {doRefill ? "Order a Refill" : "Quick Follow-up Visit"}&nbsp;
          <NavigateNextIcon />
        </Button>
      )}
    </Card>
  );
}

export default function PortalPrescriptionRefills() {
  const classes = useStyles();
  const portalClasses = usePortalStyles();
  const [showAffiliateLink, setShowAffiliateLink] = React.useState(true);
  clearUserAlreadyExists();

  return (
    <main className={classes.content}>
      {/* TODO: start showing after feature tested in production */}
      {/* {showAffiliateLink && (
        <AffiliateLink setShowAffiliateLink={setShowAffiliateLink} />
      )} */}

      <GetPatientRecord
        classes={portalClasses}
        style={portalClasses.kickContainer}
      ></GetPatientRecord>
    </main>
  );
}

function setCookiesAndRedirectToPerformanceVisitPaymentRefill(
  patient,
  visit,
  prescription
) {
  setProperVisitCookiesForRefills(patient, visit, prescription);
  const consultationType =
    CONSULTATION_TYPE_ABBREVIATION_PERFORMANCE_ANXIETY_FOLLOW_UP;
  window.location.href = `/visits/${consultationType}/payment/order-details`;
}

function setCookiesAndRedirectToSelectPharmacy(userID, email, phone, visit) {
  setProperVisitCookies(userID, visit.id, "", email, phone);
  setFollowUpVisitFlag(
    [
      VISIT_TYPE_PERFORMANCE_ANXIETY_FOLLOW_UP,
      VISIT_TYPE_INSOMNIA_FOLLOW_UP,
    ].includes(visit.visitType)
      ? "yes"
      : ""
  );

  let consultationType;

  switch (visit.visitType) {
    case VISIT_TYPE_PERFORMANCE_ANXIETY:
      consultationType = CONSULTATION_TYPE_ABBREVIATION_PERFORMANCE_ANXIETY;
      break;
    case VISIT_TYPE_PERFORMANCE_ANXIETY_FOLLOW_UP:
      consultationType =
        CONSULTATION_TYPE_ABBREVIATION_PERFORMANCE_ANXIETY_FOLLOW_UP;
      break;
    case VISIT_TYPE_INSOMNIA:
      consultationType = CONSULTATION_TYPE_ABBREVIATION_INSOMNIA;
      break;
    case VISIT_TYPE_INSOMNIA_FOLLOW_UP:
      consultationType = CONSULTATION_TYPE_ABBREVIATION_INSOMNIA_FOLLOW_UP;
      break;
    default:
      consultationType = CONSULTATION_TYPE_ABBREVIATION_PERFORMANCE_ANXIETY;
  }

  window.location.href = `/visits/${consultationType}/select-pharmacy`;
}
